import { Outlet, useLocation } from "react-router-dom";
import UserSidebar from "./UserSidebar";
import "./userPanel.css";

export default function UserPanelLayout() {
  const location = useLocation();

  // Song page detect
  const isSongPage = location.pathname.includes("/song/");

  return (
    <div
      className={`user-panel-wrapper ${
        isSongPage ? "song-theme-wrapper" : ""
      }`}
    >
      <UserSidebar />

      <main className="user-panel-content">
        <Outlet />
      </main>
    </div>
  );
}